import { keepPreviousData, skipToken } from "@tanstack/react-query";
import { can } from "@remi/permissions";
import type { InboxViewList } from "@remi/types/inbox-view";

import { api } from "~/utils/api";
import { useUserProfile } from "~/contexts/UserProfileContext";

export const useInboxViews = (
  input?: InboxViewList,
  options?: { enabled?: boolean; staleTime?: number; keepPreviousData?: boolean },
) => {
  const { user } = useUserProfile();
  const enabled = (options?.enabled ?? true) && can.inbox.list(user);
  return api.communication.listInboxViews.useQuery(input ?? skipToken, {
    enabled,
    staleTime: options?.staleTime,
    placeholderData: options?.keepPreviousData === true ? keepPreviousData : undefined,
  });
};
